import { IdentityService } from './../identity/identity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AdminUserGuard {
  constructor(
    protected readonly identityService: IdentityService,
    protected readonly router: Router,
  ) {}
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Not signed in: carry the destination so login can return here instead of dropping
    // the user on the dashboard. isUserVerified implies hasCurrentIdentity.
    if (!this.identityService.isUserVerified) {
      this.router.navigate(['/account/login'], { queryParams: { callbackUrl: state.url } });
      return false;
    }
    // Signed in but not an admin: root. A callbackUrl here would bounce them back and forth.
    if (!this.identityService.currentIdentity.isAdmin()) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
